// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__TJUAX","faq__inner":"Faq_faq__inner__lSpsF","faq__coin":"Faq_faq__coin__rQKbw","faq__wrap":"Faq_faq__wrap__gk6Bq","faq__title":"Faq_faq__title__syRt8"};